
import { SectionOrFilter } from "../filterTypes"
import {messages} from "./messages"

//Fields that you can search by keyword on the search input.
export const bundlesListFields = [
    "title",
    "titleKeyword",
    "titleAnalyzed",
    "titleSort",
    "sku",
    "manufacturerSku",
    "manufacturerSkuKeyword",
    "manufacturerSkuText",
    "skuKeyword",
    "skuText",
    
]

export const bundlesListTotals = []

export const getBundlesFilters = (context) => {
    
    const availableFilters: SectionOrFilter[] =
        [
            {
                nameId: "isArchived",
                label: context.intl.formatMessage(messages["is_archived"]),
                filterMatch: "isArchived",
                type: "boolean",
                placeHolder: "Show archived",
                initialValue: "",
                initialSelect: "is",
            },
            {
                nameId: "titleKeyword",
                label: context.intl.formatMessage(messages["bundle_title"]),
                filterMatch: "titleKeyword",
                type: "text",
                initialValue: "",
                initialSelect: "is"
            },
            {
                nameId: "skuKeyword",
                label: context.intl.formatMessage(messages["bundle_sku"]),
                filterMatch: "skuKeyword",
                type: "text",
                initialValue: "",
                initialSelect: "is"
            },
            {
                nameId: "manufacturerSkuKeyword",
                label: context.intl.formatMessage(messages["product_manufacturer_sku"]),
                filterMatch: "manufacturerSkuKeyword",
                type: "text",
                initialValue: "",
                initialSelect: "is"
            },
            {
                nameId: "labelIds",
                label: context.intl.formatMessage(messages["bundle_label"]),
                filterMatch: "labelIds",
                type: "select",
                typeOfSelect: "product-label-select",
                initialValue: [],
                initialSelect: "isOneOf"
            },
            {
                nameId: "updatedAt",
                label: context.intl.formatMessage(messages["updated_at"]),
                filterMatch: "updatedAt",
                type: "date",
                initialValue: { startDate: null, endDate: null },
                initialSelect: "is"
            },
            {
                nameId: "shortDescriptionKeyword",
                label: context.intl.formatMessage(messages["short_description"]),
                filterMatch: "shortDescriptionKeyword",
                type: "text",
                initialValue: "",
                initialSelect: "is"
            },
            {
                nameId: "defaultPrice",
                label: context.intl.formatMessage(messages["default_price"]),
                filterMatch: "defaultPrice",
                type: "number",
                initialValue: "",
                initialSelect: "is"
            }
            
        ]
    return availableFilters
}


// WEBPACK FOOTER //
// ./src/common/search-filter/search/bundleFilters/bundlesFilters.ts